export default __webpack_public_path__ + "static/media/FS-HOME-ACERCA-BENEFICIO-SEGURIDAD-ICONO.cf28aad2.svg";